import { activatedEnterModeTag, getMentionOutputHTML } from '@/ckeditorConfig'

/**
 * This functions helps in replying to an event. It takes event object, reads the current comment, loads the editor and adds the comment as blockquote. It also adds a mention to actor of the event.
 * @param event
 * @param store
 * @param commentEditorRef
 */
export default (event, store, commentEditorRef) => {
  const eventActor = store.getters.userById(event.actorId)
  const comment = event.comment
  const mention = getMentionOutputHTML(event.actorId, eventActor.displayName)
  const quote = comment ? `<blockquote>${comment}</blockquote>` : ''
  const prefilledComment = `${quote}<${activatedEnterModeTag}>${mention}&#8203;&nbsp;</${activatedEnterModeTag}>` // &#8203; is a zero-width space. For cursor to move after &nbsp;, it needed more than 1 HTML entities at the end.
  commentEditorRef.triggerReply(prefilledComment)
}
